"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    version: "1.1",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsxs)("radialGradient", {
        cx: "19.25%",
        cy: "99.4466191%",
        fx: "19.25%",
        fy: "99.4466191%",
        r: "108.96%",
        gradientTransform: "translate(0.192500,0.994466),scale(1.000000,0.999911),translate(-0.192500,-0.994466)",
        id: "messenger-radialGradient-1",
        children: [(0, _jsxRuntime.jsx)("stop", {
          stopColor: "#0099FF",
          offset: "0%"
        }), (0, _jsxRuntime.jsx)("stop", {
          stopColor: "#A033FF",
          offset: "60.98%"
        }), (0, _jsxRuntime.jsx)("stop", {
          stopColor: "#FF5280",
          offset: "93.48%"
        }), (0, _jsxRuntime.jsx)("stop", {
          stopColor: "#FF7061",
          offset: "100%"
        })]
      })
    }), (0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: (0, _jsxRuntime.jsxs)("g", {
        id: "Facebook_Messenger_logo_2020",
        transform: "translate(4.000000, 4.000000)",
        fillRule: "nonzero",
        children: [(0, _jsxRuntime.jsx)("path", {
          d: "M8,0 C3.494,0 0,3.302 0,7.76 C0,10.092 0.956,12.108 2.512,13.5 C2.642,13.616 2.722,13.78 2.726,13.956 L2.77,15.38 C2.784,15.834 3.252,16.13 3.668,15.946 L5.256,15.246 C5.39,15.186 5.542,15.176 5.684,15.214 C6.414,15.414 7.19,15.522 8,15.522 C12.506,15.522 16,12.22 16,7.762 C16,3.304 12.506,0 8,0 Z",
          id: "Path",
          fill: "url(#messenger-radialGradient-1)"
        }), (0, _jsxRuntime.jsx)("path", {
          d: "M3.196,10.03 L5.546,6.302 C5.92,5.708 6.72,5.562 7.282,5.982 L9.152,7.384 C9.324,7.512 9.56,7.512 9.73,7.382 L12.254,5.466 C12.59,5.21 13.03,5.614 12.806,5.972 L10.454,9.698 C10.08,10.292 9.28,10.438 8.718,10.018 L6.848,8.616 C6.676,8.488 6.44,8.488 6.27,8.618 L3.746,10.534 C3.41,10.79 2.97,10.388 3.196,10.03 Z",
          id: "Path",
          fill: "#FFFFFF"
        })]
      })
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Messenger.js.map